import { Input, notify, ShowInfo} from './../utils';
import {FormProvider, useForm} from 'react-hook-form';
import {useState} from 'react';
import {Toaster} from 'react-hot-toast';
import { adminLogin } from '../../api/AdminPortalApi';
import { useDispatch } from 'react-redux';
import { setAdminToken } from '../redux/actions/AdminPortalAction';
import { useNavigate } from "react-router-dom";
import { apiClient } from '../../api/ApiClient';

export default function LoginAdmin() {

    const dispatch = useDispatch();
    const methods = useForm();
    const navigate = useNavigate();
    const [isSubmitted, setIsSubmitted] = useState(false);


    const onSubmit = methods.handleSubmit(data => {
        setIsSubmitted(true);

        const adminData = {
            "username": data.username,
            "password": data.password
        }

        adminLogin(adminData).then(response => {

            if(response.data.token){
                const jwtToken ='Bearer ' + response.data.token

                apiClient.interceptors.request.use(
                    (config) => {
                        config.headers.Authorization = jwtToken
                        return config
                    }
                )
                dispatch(setAdminToken({
                    token: response.data.token,
                    refreshToken: response.data.refreshToken,
                    tokenExpiresIn: response.data.tokenExpiresIn,
                    refreshTokenExpiresIn: response.data.refreshTokenExpiresIn,
                }))
    
                setIsSubmitted(false)
    
                navigate('/admin/portal')
            }else{
                setIsSubmitted(false)
                notify('کاربر یافت نشد.')
            }
            

        }).catch(error => {
            if(error.code == 'ERR_NETWORK') {
                notify('ارتباط با شبکه قطع است. اتصال اینترنت خود را بررسی کنید.')
            }else{
                notify(error?.response?.data?.message)
            }

            setIsSubmitted(false)
        })

    })


    return (

        <div>
            <Toaster/>
            <ShowInfo
                title={'پنل مدیریت'}
                message={'لطفا اطلاعات خود را با دقت وارد نمایید.'}
            />

            <FormProvider {...methods}>
                <form
                    onSubmit={e => e.preventDefault()}
                    noValidate
                    className="container"
                >
                    <Input
                        lable_text="نام کاربری"
                        type="text"
                        name="username"
                        placeholder="نام کاربری خو را وارد کنید"
                        validation={{
                            required: {
                                value: true,
                                message: 'لطفا نام کاربری خود را وارد کنید',
                            },
                        }}
                    />

                    <Input
                        lable_text="رمز عبور"
                        type="password"
                        name="password"
                        placeholder="رمز عبور خود را وارد کنید"
                        validation={{
                            required: {
                                value: true,
                                message: 'لطفا رمز عبور خود را وارد کنید',
                            },
                        }}
                    />

                    <div className='row justify-content-center mb-5 mt-5 '>
                        <div className='col-12 col-md-5'>
                            <button
                                onClick={onSubmit}
                                className='btn w-100 text-form-button'
                                style={{"background": "#044448"}}
                                disabled={isSubmitted}>
                                ورود
                            </button>
                        </div>
                    </div>
                </form>
            </FormProvider>


            {isSubmitted && (
                <div className="loading-overlay">
                    <div className="loading-content">
                        <div className="spinner"></div>
                        <p className='loader-text mt-3'>لطفا چند لحظه منتظر بمانید</p>
                    </div>
                </div>
            )}

        </div>

    )
}